<template>
    <el-dialog class="comn_dialog" :visible.sync="visible" :width="popupWidth" :close-on-click-modal="false"
        :modal="false" @close="Cancel">
        <div class="form-tit" style="margin-top: 0;">基本情報</div>
        <el-divider></el-divider>
        <div class="form-main">
            <div class="form-item">
                <div class="form-text">注文番号：</div>
                <div>{{ order.code }}</div>
            </div>
            <div class="form-item little">
                <div class="form-text">営業担当：</div>
                <div>{{ order.salesResponsiblePerson }}</div>
            </div>
            <div class="form-item little">
                <div class="form-text">製品納期：</div>
                <div>{{ order.desiredDeliveryDate }}</div>
            </div>
            <div class="form-item">
                <div class="form-text">延期するか：</div>
                <div>{{ order.delayFlag }}</div>
            </div>
        </div>
        <div class="form-tit">見積もり情報</div>
        <el-divider></el-divider>
        <div class="form-main">
            <div class="form-item">
                <div class="form-text">見積もり番号：</div>
                <div>{{ order.quoteNumber }}</div>
            </div>
            <!-- <div class="form-item">
                <div class="form-text">状態：</div>
                <div>{{ order.status }}</div>
            </div> -->
            <div class="form-item little">
                <div class="form-text">数量：</div>
                <div>{{ order.quoteQuantity }}</div>
            </div>
            <div class="form-item little">
                <div class="form-text">見積もり日付：</div>
                <div>{{ order.replyDate }}</div>
            </div>
            <div class="form-item">
                <div class="form-text">抛点：</div>
                <div>{{ order.location }}</div>
            </div>
        </div>
        <div class="form-main">


            <div class="form-item">
                <div class="form-text">単価/RMB：</div>
                <div>{{ order.unitPrice }}</div>
            </div>
            <div class="form-item little">
                <div class="form-text">金額/RMB：</div>
                <div>{{ order.quoteTotalAmount }}</div>
            </div>
            <div class="form-item little">
                <div class="form-text">単価/JPY：</div>
                <div>{{ order.unitPriceJpy }}</div>
            </div>
            <div class="form-item">
                <div class="form-text">金額/JPY：</div>
                <div>{{ order.quoteTotalAmountJpy }}</div>
            </div>
        </div>
        <div class="form-main">
            <div class="form-item">
                <div class="form-text">見積もり図面：</div>
                <div class="blue-text" @click="viewPdf(order.bjPdf)">{{ order.bjName }}</div>
            </div>

            <div class="form-item little">
                <div class="form-text"></div>
                <div></div>
            </div>
            <div class="form-item little">
                <div class="form-text"></div>
                <div></div>
            </div>
            <div class="form-item">
                <div class="form-text"></div>
                <div></div>
            </div>
        </div>

        <div class="form-tit">受注情報</div>
        <el-divider></el-divider>
        <div class="form-main">
            <div class="form-item">
                <div class="form-text">受注日付：</div>
                <div>{{ order.orderCreateTime }}</div>
            </div>
            <div class="form-item little">
                <div class="form-text">受注数量：</div>
                <div>{{ order.orderQuantity }}</div>
            </div>
            <div class="form-item little">
                <div class="form-text">受注金額：</div>
                <div>{{ order.orderTotalAmount }}</div>
            </div>
            <div class="form-item">
                <div class="form-text">受注図面：</div>
                <div class="blue-text" @click="viewPdf(order.orderPdf)">{{ order.orderName }}</div>
            </div>
        </div>

        <div class="form-tit">検査情報</div>
        <el-divider></el-divider>
        <div class="form-main">
            <div class="form-item">
                <div class="form-text">入荷日付：</div>
                <div>{{ order.checkOpDate }}</div>
            </div>
            <div class="form-item little">
                <div class="form-text">検査日付：</div>
                <div>{{ order.checkDate }}</div>
            </div>
            <div class="form-item little">
                <div class="form-text">MIC検査：</div>
                <div>{{ order.result1 }}</div>
            </div>
            <div class="form-item">
                <div class="form-text">検査写真：</div>
                <div class="blue-text" @click="viewPdf(order.checkPdf)">{{ order.checkName }}</div>
            </div>
        </div>
        <div class="form-tit">出荷情報</div>
        <el-divider></el-divider>
        <div class="form-main">
            <div class="form-item">
                <div class="form-text">出荷日付：</div>
                <div>{{ order.outDate }}</div>
            </div>
            <div class="form-item little">
                <div class="form-text">箱番号：</div>
                <div>{{ order.boxNumber }}</div>
            </div>
            <div class="form-item little">
                <div class="form-text">物流会社：</div>
                <div>{{ order.expCompany }}</div>
            </div>
            <div class="form-item">
                <div class="form-text">物流番号：</div>
                <div>{{ order.expNo }}</div>
            </div>
        </div>

        <span slot="footer" class="dialog-footer">
            <el-button @click="Cancel">取 消</el-button>
        </span>

    </el-dialog>
</template>
<script>
import axios from "axios";
import micUrl from "../../../mic";
export default {
    props: {
        centerDialogVisible: {
            type: Boolean,
            default() {
                return false;
            }
        },
        popupWidth: {
            type: String,
            default() {
                return "970px";
            }
        },
        popupTop: {
            type: String,
            default() {
                return "15vh";
            }
        },
        orderInfo: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            // 注文信息
            order: {
                // 基本信息
                code: '',
                salesResponsiblePerson: '',
                desiredDeliveryDate: '',
                delayFlag: '',
                // 見積情報
                quoteNumber: '',
                status: '',
                quoteQuantity: '',
                replyDate: '',
                location: '',
                // 見積情報
                unitPrice: '',
                quoteTotalAmount: '',
                unitPriceJpy: '',
                quoteTotalAmountJpy: '',
                bjPdf: '',
                bjName: '',
                // 受注信息
                orderCreateTime: '',
                orderQuantity: '',
                orderTotalAmount: '',
                orderPdf: '',
                orderName: '',
                // 入荷信息
                checkOpDate: '',
                checkDate: '',
                result: '',
                result1: '',
                checkPdf: '',
                // 出荷信息
                outDate: '',
                expCompany: '',
                expNo: '',
            }
        }
    },
    computed: {
        visible: {
            get() {
                return this.centerDialogVisible;
            },
            set(val) {
                this.$emit("updateVisible", val);
            }
        }
    },
    watch: {
        visible: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.query();
                }
            }
        }
    },
    methods: {
        Cancel() {
            this.$emit("resetPopupData");
        },
        Save() {
            this.$emit("submitPopupData");
        },
        // 页面打开查询
        query() {
            // 重置数据
            this.order = {
                // 基本信息
                code: '',
                salesResponsiblePerson: '',
                desiredDeliveryDate: '',
                delayFlag: '',
                // 見積情報
                quoteNumber: '',
                status: '',
                quoteQuantity: '',
                replyDate: '',
                location: '',
                // 見積情報
                unitPrice: '',
                quoteTotalAmount: '',
                unitPriceJpy: '',
                quoteTotalAmountJpy: '',
                bjPdf: '',
                bjName: '',
                // 受注信息
                orderCreateTime: '',
                orderQuantity: '',
                orderTotalAmount: '',
                orderPdf: '',
                orderName: '',
                // 入荷信息
                checkOpDate: '',
                checkDate: '',
                result: '',
                result1: '',
                checkPdf: '',
                // 出荷信息
                outDate: '',
                expCompany: '',
                expNo: '',
            }
            new Promise((resolve, reject) => {
                try {
                    axios.get(`${micUrl}Miku/pdfhandle/getInfo/${this.orderInfo.id}`, {
                        // 携带token
                        headers: {
                            'Accesstoken': sessionStorage.getItem('accessToken')
                        }
                    }).then((res) => {
                        console.log(res.data, 'res.data ')
                        if (res.data.code == 200) {
                            this.order = res.data.data;
                            console.log(this.order, 'this.order ')
                            // 从pdf链接截取文件名
                            // 报价图纸
                            this.order.bjName = this.order.bjPdf == '' || this.order.bjPdf == null || this.order.bjPdf == undefined ? '' : this.order.bjPdf.split('/').pop();
                            // 受注图纸
                            this.order.orderName = this.order.orderPdf == '' || this.order.orderPdf == null || this.order.orderPdf == undefined ? '' : this.order.orderPdf.split('/').pop();
                            // 检查写真
                            this.order.checkName = this.order.checkPdf == '' || this.order.checkPdf == null || this.order.checkPdf == undefined ? '' : this.order.checkPdf.split('/').pop();
                            // 检查结果
                            if (this.order.result == '' || this.order.result == null || this.order.result == undefined) {
                                this.order.result1 = 'MIC未検査';
                            } else {
                                if (this.order.result == '1') {
                                    this.order.result1 = '合格';
                                } else if (this.order.result == '2') {
                                    this.order.result1 = '不具合';
                                }
                            }
                        }
                    }).catch((err) => {
                        reject(err);
                    })
                } catch (error) {
                    console.log(error);
                }
            })

        },
        // 查看图纸
        viewPdf(pdfUrl) {
            window.open(pdfUrl, '_blank');
        }
    },
    mounted() {
        if (this.visible) {
            this.query();
        }
    },

};
</script>
<style lang="scss">
.form-tit {
    text-align: left;
    font-size: 22px;
    font-weight: bold;
    margin-top: 10px;
}

.form-main {
    padding: 5px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.form-text {
    font-size: 14px;
}

.form-item {
    display: flex;
    align-items: center;
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.el-divider--horizontal {
    margin: 0;
    margin-top: 5px;
    margin-bottom: 10px;
}

.blue-text {
    color: #2830d3;
    cursor: pointer;
}

.little {
    flex: 0.7;
}
</style>